export default {
    getTotalQuantity(state)  {
        return Object.values(state.products).reduce(function(totalQuantity, product){
            return parseInt(totalQuantity) + parseInt(product.quantite);
        }, 0);
    }
};
